var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import Calendar from 'devextreme/ui/calendar';
import { DateHelper } from '../../helpers/index';
import { DinapsisDateRangeBase } from './dinapsis-date-range-base';
/**
 * Represents the dinapsis-date-range-calendar component, that allow select a
 * date interval in a calendar.
 */
let DinapsisDateRangeCalendar = class DinapsisDateRangeCalendar extends DinapsisDateRangeBase {
    constructor() {
        super();
        /**
         * A property that is used to set the id of the div that the date-range
         * calendar is rendered in.
         */
        this.calendarId = 'dinapsis-date-range-calendar';
        /**
         * Calendar component.
         */
        this.calendar = undefined;
        /**
         * Define template of a cell. If cell is between start and end date draw it
         * diferent as other cell.
         * @param cellInfo Information of a cell. Property 'text' contains the text
         * of the cell.
         * @param _index Index in the week of the cell.
         * @param container Container of the calendar.
         * @returns String with HTML template for the cell.
         */
        this.cellTemplate = (cellInfo, _index, container) => {
            const cellDate = new Date(DateHelper.getYearMonthDayString(cellInfo.date));
            const start = this.startDate ? new Date(this.startDate) : '';
            const end = this.endDate ? new Date(this.endDate) : '';
            let cellHtml = `<span class="date-range-cell">${cellInfo.text}</span>`;
            if (this.startDate && this.endDate && cellDate >= start && cellDate <= end) {
                if (container) {
                    container.classList.add('dx-calendar-selected-date');
                    if (cellDate.valueOf() === start.valueOf()) {
                        if (start.valueOf() === end.valueOf()) {
                            cellHtml = `<span class="start">${cellInfo.text}</span>`;
                        }
                        else {
                            cellHtml = `
              <div class="start-between">&nbsp;</div>
              <span class="start">${cellInfo.text}</span>
            `;
                        }
                    }
                    else if (cellDate.valueOf() === end.valueOf()) {
                        cellHtml = `
            <div class="end-between">&nbsp;</div>
            <span class="end">${cellInfo.text}</span>
          `;
                    }
                    else {
                        cellHtml = `<div class="between">${cellInfo.text}</div>`;
                    }
                }
            }
            return `<div class="data-range-cell">${cellHtml}</div>`;
        };
        /**
         * Value changed handler.
         * @param param0 Object with information of the selected value in the
         * calendar.
         */
        this.onValueChanged = ({ component, value, event }) => {
            const calendar = component;
            if (value) {
                const selectedDate = DateHelper.getYearMonthDayString(value);
                if (this.endDate !== this.startDate || selectedDate < this.startDate) {
                    this.startDate = selectedDate;
                    this.endDate = selectedDate;
                }
                else {
                    this.endDate = selectedDate;
                }
            }
            calendar.repaint();
            calendar.focus();
            this.emitDatesChangedEvent(event);
        };
        const now = DateHelper.getYearMonthDayString(new Date());
        this.startDate = now;
        this.endDate = now;
    }
    /**
     * The above function is a lifecycle hook that is called when the component
     * is first updated. It is used to initialize the calendar view.
     */
    firstUpdated() {
        const calendarContainer = document.getElementById(this.calendarId);
        if (calendarContainer) {
            // Instance Creation
            this.calendar = new Calendar(calendarContainer);
            this.calendar.option('cellTemplate', this.cellTemplate);
            this.calendar.option('onValueChanged', this.onValueChanged);
        }
    }
    /**
     * The above function is a lifecycle hook that is called when the component is updated.
     * It is used to updated the calendar.
     */
    updated(changedProperties) {
        if (changedProperties.has('startDate') || changedProperties.has('endDate')) {
            if (!this.calendar)
                return;
            this.calendar.repaint();
            this.calendar.focus();
            this.calendar.option('value', undefined);
        }
    }
    /**
     * Emits the dates changed event with the start and end date.
     */
    emitDatesChangedEvent(event) {
        let position = null;
        if (event !== undefined) {
            position = -1;
        }
        this.dispatchEvent(new CustomEvent('dates-changed', {
            detail: {
                startDate: this.startDate,
                endDate: this.endDate,
                intervalPosition: position,
            },
        }));
    }
    /**
     * The createRenderRoot function is a function that is called by the lit-html
     * library to tell the component where to render the html.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Renders the template literal HTML of the component.
     * @returns The HTML template literal.
     */
    render() {
        return html `
      <div class="date-range-calendar" id="${this.calendarId}"></div>
    `;
    }
};
__decorate([
    property({ type: String })
], DinapsisDateRangeCalendar.prototype, "calendarId", void 0);
DinapsisDateRangeCalendar = __decorate([
    customElement('dinapsis-date-range-calendar')
], DinapsisDateRangeCalendar);
export { DinapsisDateRangeCalendar };
//# sourceMappingURL=dinapsis-date-range-calendar.js.map